import React from "react";
import Assets from "imports/assets.import";
import { STRINGS } from "constants/strings.constant";
import "./editor_canvas_note.component.scss";

// The line at the bottom of the canvas explaining why the target picture looks faded.
const EditorCanvasNote = () => {
    return (
        <p className="editor_canvas_note">
            <img src={Assets.info_circle} alt="" />
            <span>{STRINGS.editor.canvasNote}</span>
        </p>
    );
};

export default EditorCanvasNote;
